<template>
  <div class="menu">
    <div class="button-section">
      <custom-icon-button
        button-name="open-menu"
        class="icon"
        iconName="bars"
        @openMenuButton="$emit('show-navigation-modal')"
      />
      <custom-icon-button
        button-name="open-menu"
        class="icon"
        iconName="money-bill-wave"
        @openMenuButton="$emit('show-payment-modal')"
      />
    </div>
  </div>
</template>

<script>
import CustomIconButton from '../common/CustomIconButton.vue';

export default {
  name: 'calendar-menu',
  components: { CustomIconButton },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

.menu {
  display: flex;
  flex-direction: column;
  height: 126px;
  margin-top: 50vh;
  position: fixed;
  right: 0;
  width: 68px;
  z-index: 30;
}

.button-section {
  height: 50%;
}

.icon {
  background-color: white;
  border-radius: 90px;
  box-shadow: 2px 2px 2px 2px $grey;
  color: $grey;
  height: 48px;
  margin: 10px 10px 0 10px;
  padding: 8px;
  transition: width .2s, height .2s;
  width: 48px;
}

.icon:last-child {
  margin-bottom: 10px;
}

.icon:hover {
  cursor: pointer;
  height: 56px;
  transition: width .2s, height .2s;
  width: 56px;
}

</style>
